<template xmlns="">
  <div>
    <v-dialog dark persistent :value="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <div class="mobile-wizard-container" :class="{ 'mobile-wizard-container--mtt': isMttMode }">
        <template v-if="windowIndex !== 2">
          <div class="my-2"><v-img src="/img/roody_logo.png" height="65px" contain /></div>
          <v-progress-linear :value="progress" color="primary" height="6" class="mobile-wizard-progress"></v-progress-linear>
        </template>

        <div v-if="isMttMode" class="mtt-editor-banner">
          <v-avatar color="primary" size="38" class="mr-3"><v-icon color="white">mdi-account-heart-outline</v-icon></v-avatar>
          <div class="mtt-editor-banner__customer">
            <div class="caption grey--text text--lighten-1">MTT-Trainingsplan für</div>
            <div class="font-weight-bold white--text">{{ mttCustomerName }}</div>
          </div>
          <v-spacer></v-spacer>
          <div class="mtt-editor-banner__physio text-right">
            <div class="caption grey--text text--lighten-1">Physio</div>
            <div class="body-2 white--text">{{ userService.getFullName() }}</div>
          </div>
        </div>

        <v-overlay :value="isMttMode && mttLoading" absolute z-index="1005">
          <div class="text-center">
            <v-progress-circular indeterminate color="primary" size="54" />
            <div class="mt-3">MTT-Kunde wird geprüft …</div>
          </div>
        </v-overlay>

        <div
          class="mobile-wizard-content"
          :style="windowIndex === 2 ? 'background: #313131' : ''"
          :class="{ 'fullscreen-content': windowIndex === 2 }">
          <v-fade-transition mode="out-in">
            <div v-if="windowIndex === 1" class="mobile-wizard-step" key="step1">
              <h1 class="text-h4 font-weight-bold mb-2">{{ formTitle }}</h1>
              <p class="body-1 grey--text text--lighten-1 mb-8">
                {{ formWindow === 1 ? "Wähle einen Kunden und Trainer aus." : "Bestimme die Art deines Trainingsplans." }}
              </p>
              <v-form lazy-validation dark ref="createForm" class="mt-4">
                <v-window touchless v-model="formWindow">
                  <v-window-item :value="1">
                    <user-search
                      filled
                      dark
                      rounded
                      :value="form.user_id"
                      rights="tp_create"
                      class="mb-5"
                      v-if="!isMttMode && userService.hasRight('tp_create')"
                      label="Kunde"
                      @update="updateCustomer"></user-search>
                    <user-search
                      filled
                      rounded
                      dark
                      :value="form.instructor_id"
                      rights="tp_create"
                      v-if="!isMttMode && userService.hasRight('tp_create')"
                      label="Trainer"
                      class="mb-5"
                      instructor
                      @update="updateInstructor"></user-search>
                    <p class="red--text" v-if="noInstructorSnackbar">Bitte Trainer auswählen</p>
                  </v-window-item>
                  <v-window-item :value="2">
                    <v-item-group :value="activeSplitValue" class="mb-6">
                      <v-col v-for="(split, index) in splitItems" cols="12" :key="index" class="px-0 py-1">
                        <v-item :value="split.value" v-slot="{ active }">
                          <v-card @click="handleSplitSelection(split)" class="split-item" :class="{ 'split-item--active': active }">
                            <div class="d-flex align-center pa-4">
                              <div class="flex-grow-1">
                                <div class="font-weight-bold text-h6">{{ split.text }}</div>
                                <p class="caption mb-0 text--lighten-2">{{ split.info }}</p>
                              </div>
                              <v-icon v-if="active" size="32" color="white">mdi-check-decagram</v-icon>
                            </div>
                          </v-card>
                        </v-item>
                      </v-col>
                      <v-col cols="12" class="px-0" style="margin-bottom: 60px">
                        <v-item value="customSplit" v-slot="{ active }">
                          <v-card @click="handleSplitSelection('customSplit')" class="split-item" :class="{ 'split-item--active': active }">
                            <div class="d-flex align-center pa-4">
                              <div class="flex-grow-1">
                                <div class="font-weight-bold text-h6">Eigener Split erstellen</div>
                                <p class="caption mb-0 text--lighten-2">Definiere deine eigenen Trainingstage (z.B. Brust/Bizeps, Rücken/Trizeps).</p>
                              </div>
                              <v-icon size="32" color="white">{{ active ? "mdi-check-decagram" : "mdi-plus-circle-outline" }}</v-icon>
                            </div>
                          </v-card>
                        </v-item>
                      </v-col>
                    </v-item-group>

                    <v-dialog dark v-model="addWorkoutToSplit" persistent max-width="450px" content-class="custom-split-dialog">
                      <v-card class="custom-split-dialog-card">
                        <v-card-title class="d-flex flex-column align-start">
                          <v-icon color="primary" large class="mb-2">mdi-pencil-ruler</v-icon>
                          <span class="text-h5 font-weight-bold">Custom Split Builder</span>
                        </v-card-title>
                        <v-card-subtitle>Benenne deine individuellen Trainingstage.</v-card-subtitle>

                        <v-card-text>
                          <v-text-field
                            solo
                            dark
                            flat
                            label="z.B. Push, Pull, Beine..."
                            v-model="addNewSplitText"
                            @keydown.enter.prevent="addWorkoutDay"
                            class="mb-3">
                            <template v-slot:append>
                              <v-btn icon color="primary" @click="addWorkoutDay" :disabled="!addNewSplitText.trim()">
                                <v-icon>mdi-plus-circle</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>

                          <v-expand-transition>
                            <div v-if="form.splits && form.splits.workouts && form.splits.workouts.length > 0">
                              <v-chip-group column class="custom-chip-group">
                                <v-chip
                                  v-for="(workout, index) in form.splits.workouts"
                                  :key="index"
                                  close
                                  @click:close="removeWorkoutDay(index)"
                                  class="custom-chip">
                                  {{ workout.title }}
                                </v-chip>
                              </v-chip-group>
                            </div>
                          </v-expand-transition>
                        </v-card-text>

                        <v-card-actions class="pa-4">
                          <v-btn text large @click="cancelCustomSplitCreation" class="font-weight-bold">Abbrechen</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            depressed
                            large
                            rounded
                            @click="finishCustomSplitCreation"
                            :disabled="!form.splits.workouts || form.splits.workouts.length === 0"
                            class="font-weight-bold">
                            <v-icon left>mdi-check</v-icon>
                            Fertig
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-window-item>
                </v-window>
              </v-form>
            </div>

            <div v-else-if="windowIndex === 2" key="step2-fullscreen">
              <workout-split-edit
                @next="windowIndex = 3"
                @return="windowIndex = 1"
                @save-split="addNewSplit"
                @nextStepError="handleNextStepForSplit = false"
                :handleNextStepForSplit="handleNextStepForSplit"
                :exerciseIds="allExerciseIdsInPlan"
                :form="form"></workout-split-edit>
            </div>

            <div v-else-if="windowIndex === 3" class="mobile-wizard-step" key="step3">
              <WorkoutSplitOverviewAndSubmit
                @return="windowIndex = 2"
                :form="form"
                @submitPlan="createWorkoutPlan"
                @resetSubmitPlan="handleSubmitPlan = false"
                :handleSubmitPlan="handleSubmitPlan"
                @updatePlan="updateWorkoutPlan" />
            </div>
          </v-fade-transition>
        </div>

        <div class="mobile-wizard-nav" :style="windowIndex === 2 ? 'background: #313131' : ''">
          <v-btn color="white" text @click="handleBackStep()" v-if="windowIndex > 1 || formWindow > 1">
            <v-icon left>mdi-chevron-left</v-icon>
            Zurück
          </v-btn>
          <v-btn v-else @click="closeCreateView">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="windowIndex < 3" color="primary" depressed @click="handleNextStep()" :disabled="isNextDisabled">
            Weiter
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn v-else depressed color="primary" @click="handleSubmitPlan = true"> Speichern </v-btn>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="showRestoreDraftDialog" persistent max-width="420" dark content-class="rounded-xl wow-dialog-card" style="z-index: 99999">
      <v-card class="rounded-xl overflow-hidden glass-overlay">
        <div class="pa-8 text-center">
          <v-icon size="80" color="primary" class="mb-4 animated-icon">mdi-content-save-edit-outline</v-icon>
          <h2 class="text-h5 font-weight-bold mb-3">Gespeicherter Entwurf</h2>
          <p class="body-1 grey--text text--lighten-1 mb-6">
            Du hast einen nicht abgeschlossenen Trainingsplan. Möchtest du an dieser Stelle weitermachen?
          </p>
          <v-btn
            depressed
            x-large
            rounded
            class="font-weight-bold pulse-animation mb-3 white--text"
            color="primary"
            block
            @click="handleRestoreDraft">
            Ja, wiederherstellen
          </v-btn>
          <v-btn dark block text @click="handleDiscardDraft">Nein, neu starten</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSplitChangeConfirmDialog" persistent max-width="450" dark>
      <v-card class="glass-card pa-2">
        <v-card-title class="font-weight-bold justify-center">
          <v-icon left color="orange">mdi-alert-circle-outline</v-icon>
          Split-Typ ändern?
        </v-card-title>
        <v-card-text class="white--text text-center mt-4">
          Wenn du einen neuen Split-Typ wählst, werden alle Übungen im aktuellen Plan zurückgesetzt. Möchtest du fortfahren?
        </v-card-text>
        <v-card-actions class="pa-4 d-flex justify-space-around">
          <v-btn text color="grey" @click="cancelSplitChange">Abbrechen</v-btn>
          <v-btn color="primary" depressed @click="confirmSplitChange">Ja, ändern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <PlanConverter
      v-if="showConversionDialog"
      :value="showConversionDialog"
      :is-standalone="false"
      @close="showConversionDialog = false"
      @conversion-complete="onConversionComplete" />
    <v-dialog v-model="showOldPlansDialog" persistent max-width="420" dark content-class="rounded-xl wow-dialog-card">
      <v-card class="rounded-xl overflow-hidden glass-overlay">
        <div class="pa-8 text-center">
          <v-icon size="80" color="primary" class="mb-4 animated-icon">mdi-history</v-icon>
          <h2 class="text-h5 font-weight-bold mb-3">Alte Pläne gefunden!</h2>
          <p class="body-1 grey--text text--lighten-1 mb-6">
            Für diesen Kunden existieren ältere Trainingspläne. Möchtest du einen davon als Basis für den neuen Plan verwenden und ihn upgraden?
          </p>
          <v-btn depressed x-large rounded class="font-weight-bold pulse-animation mb-3 white--text" color="primary" block @click="startConversion">
            Plan upgraden
          </v-btn>
          <v-btn dark block text @click="skipConversion">Neu erstellen</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api"
import userSearch from "../../components/userSearch.vue"
import { mapState, mapActions, mapGetters } from "vuex"
import userService from "../../services/userService"
import workoutSplitEdit from "./WorkoutSplitEdit.vue"
import WorkoutSplitOverviewAndSubmit from "./WorkoutSplitOverviewAndSubmit.vue"
import PlanConverter from "./v2/planConverter.vue"
import { debounce } from "./v2/utils/debounce" // <-- DIESE ZEILE HINZUFÜGEN

export default {
  name: "WorkoutCreate",
  components: {
    userSearch,
    workoutSplitEdit,
    WorkoutSplitOverviewAndSubmit,
    PlanConverter,
  },
  data() {
    return {
      mttCustomer: null,
      mttLoading: false,
      showSplitChangeConfirmDialog: false, // <-- HINZUFÜGEN
      pendingSplitSelection: null, // <-- HINZUFÜGEN
      showOldPlansDialog: false,
      showRestoreDraftDialog: false, // <-- HIER HINZUFÜGEN

      showConversionDialog: false,
      formWindow: 1,
      windowIndex: 1,
      handleNextStepForSplit: false,
      addNewSplitText: "",
      addWorkoutToSplit: false,
      handleSubmitPlan: false,
      splitItems: [
        {
          text: "Ganzkörper-Training",
          value: "fullBodySplit",
          info: "Jede Trainingseinheit trainiert den gesamten Körper.",
          workouts: [
            {
              title: "Ganzkörper",
              exercises: [],
              recommendedTags: [
                "Schienbein",
                "Rundmuskel",
                "Trapez",
                "Trizeps",
                "Latissimus",
                "Rückenstrecker",
                "Gesäss",
                "Beinbeuger",
                "Wade",
                "Vordere Schulter",
                "Scholle",
                "Seitliche Schulter",
                "Brust",
                "Hintere Schulter",
                "Gerader Bauch",
                "Bizeps",
                "Seitlicher Bauch",
                "Unterarm Unten",
                "Oberschenkel",
                "Nacken",
                "Adduktoren",
                "Unterarm Oben",
                "Herz-Kreislauf",
                "Dehnen",
                "Abduktoren",
              ],
            },
          ],
        },
        {
          text: "Oberkörper-/Unterkörper Split",
          value: "upperLowerSplit",
          info: "Ein Tag ist für den Oberkörper, der andere für den Unterkörper.",
          workouts: [
            {
              exercises: [],
              title: "Oberkörper",
              recommendedTags: [
                "Brust",
                "Vordere Schulter",
                "Seitliche Schulter",
                "Hintere Schulter",
                "Bizeps",
                "Trizeps",
                "Rückenstrecker",
                "Latissimus",
                "Trapez",
                "Unterarm Unten",
                "Unterarm Oben",
                "Gerader Bauch",
                "Seitlicher Bauch",
                "Nacken",
              ],
            },
            {
              exercises: [],
              title: "Unterkörper",
              recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle", "Gesäss", "Schienbein"],
            },
          ],
        },
        {
          text: "Push/Pull/Beine-Split",
          value: "pushPullLegSplit",
          info: "Drückende (Push), ziehende (Pull) Muskeln und Beine an separaten Tagen.",
          workouts: [
            {
              exercises: [],
              title: "Push",
              recommendedTags: ["Brust", "Vordere Schulter", "Trizeps", "Seitliche Schulter"],
            },
            {
              exercises: [],
              title: "Pull",
              recommendedTags: ["Rückenstrecker", "Latissimus", "Trapez", "Bizeps", "Hintere Schulter", "Unterarm Unten", "Unterarm Oben"],
            },
            {
              exercises: [],
              title: "Beine",
              recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle"],
            },
          ],
        },
        {
          text: "Bro-Split",
          value: "broSplit",
          info: "Jede Muskelgruppe hat einen eigenen Trainingstag.",
          workouts: [
            { title: "Brust", recommendedTags: ["Brust", "Seitlicher Bauch", "Gerader Bauch"], exercises: [] },
            { title: "Rücken", exercises: [], recommendedTags: ["Latissimus", "Rückenstrecker", "Trapez", "Schienbein"] },
            { title: "Schultern", exercises: [], recommendedTags: ["Vordere Schulter", "Seitliche Schulter", "Hintere Schulter", "Nacken"] },
            { title: "Beine", exercises: [], recommendedTags: ["Oberschenkel", "Wade", "Beinbeuger", "Adduktoren", "Abduktoren", "Scholle"] },
            { title: "Arme", exercises: [], recommendedTags: ["Bizeps", "Trizeps", "Unterarm Unten", "Unterarm Oben"] },
          ],
        },
      ],
      dialog: true,
      noInstructorSnackbar: false,
      userService,
      form: {
        picture: null,
        title: "",
        duration: "",
        user_id: null,
        instructor_id: null,
        splits: { text: "", workouts: [] },
      },
    }
  },
  // methods-Block ersetzen
  async created() {
    if (this.isMttMode) {
      await this.initializeMttMode()
      return
    }

    if (this.$route.params.isClone === "true" && this.planToClone) {
      // 1. Lade eine tiefe Kopie der Vorlage aus dem Vuex-Store
      const clonedData = JSON.parse(JSON.stringify(this.planToClone.form))

      delete clonedData._id
      delete clonedData.createdAt // <-- Der entscheidende Fix
      delete clonedData.updatedAt // (Gute Praxis, dies ebenfalls zu entfernen)
      clonedData.user_id = null

      clonedData.title = `Kopie von: ${clonedData.title}`

      this.form = clonedData

      this.resetPlanForCloning() // (Diese Vuex-Action musst du noch erstellen)

      this.formWindow = 1
      this.windowIndex = 1
      return
    }
    if (this.$route.params.conversion && this.planForConversion) {
      this.form = JSON.parse(JSON.stringify(this.planForConversion))
      this.windowIndex = 2
      this.resetPlanForConversion()
    } else if (this.isInEditMode) {
      if (this.planInEditMode && this.planInEditMode.form) {
        this.form = JSON.parse(JSON.stringify(this.planInEditMode.form))
        this.windowIndex = 2
      } else {
        console.error("Konnte Trainingsplan im Bearbeitungsmodus nicht laden.")
        this.$router.push("/workout/hub")
        return
      }
    } else {
      // START: Korrigierte Logik für NEUERSTELLUNG & WIEDERHERSTELLUNG
      this.resetPlanInEditMode()

      // 1. Zuerst versuchen, die IDs vom Panel zu übernehmen
      const customerId = this.$route.query.userId || this.selectedCustomer?._id
      const instructorId = this.getSelectedEmployee?.user

      console.log(customerId, instructorId, "haaaalllooo nachbar")
      // 2. Prüfen, ob ein Entwurf existiert und den Benutzer fragen
      const draft = this.workoutV2Create?.form
      const isDraftValid = draft && draft.splits?.workouts?.length > 0 && draft.splits.workouts.some((s) => s.exercises && s.exercises.length > 0)
      console.log(draft, isDraftValid, "DRAFTTTT")
      // 2. Frage nur, wenn der Entwurf auch wirklich Inhalt hat.
      if (isDraftValid) {
        console.log("Es gibt einen gültigen Entwurf, zeige Dialog an.")
        this.showRestoreDraftDialog = true
        return
      }

      // 3. Wenn kein Entwurf wiederhergestellt wurde: Starte mit einem sauberen Formular
      this.resetWorkoutV2CreateForm()
      this.form = JSON.parse(JSON.stringify(this.workoutV2Create.form)) // Lokales Formular synchronisieren

      // 4. Jetzt die IDs (falls vorhanden) in das saubere Formular eintragen
      if (customerId) {
        this.form.user_id = customerId
      }
      if (instructorId) {
        this.form.instructor_id = instructorId
      }

      // 5. Prüfen, ob beide IDs gesetzt sind, um automatisch zur nächsten Seite zu springen
      if (this.form.user_id && this.form.instructor_id) {
        this.$nextTick(async () => {
          this.formWindow = 2 // Springe zur Split-Auswahl
          await this.loadOldPlansForUser(this.form.user_id)
          if (this.oldWorkoutPlans && this.oldWorkoutPlans.length > 0 && !this.isInEditMode && this.$route.params.isClone !== "true") {
            this.showOldPlansDialog = true
          }
        })
      }
    }
  },
  computed: {
    isMttMode() {
      return this.$route.name === "MttWorkoutCreate" || this.$route.name === "MttWorkoutEdit"
    },
    workoutAccessMode() {
      if (this.isMttMode) return "mtt"
      return userService.hasRight("tp_create") ? "trainer" : false
    },
    mttCustomerName() {
      if (!this.mttCustomer) return "Wird geladen …"
      return `${this.mttCustomer.vorname || ""} ${this.mttCustomer.nachname || ""}`.trim()
    },
    ...mapGetters("runWorkoutStore", ["planForConversion", "oldWorkoutPlans", "planToClone"]),
    ...mapState("runWorkoutStore", ["planInEditMode"]),
    ...mapGetters("studioStore", ["getSelectedEmployee"]),
    ...mapState("workingoutStore", ["splitWorkoutCreationStore"]), // <-- DIESE ZEILE HINZUFÜGEN

    ...mapState("workingoutStore", ["workoutCreateExercises", "workoutCreate", "workoutV2Create"]),
    ...mapGetters("panelStore", { selectedCustomer: "getSelectedCustomer" }),
    allExerciseIdsInPlan() {
      if (!this.form || !this.form.splits || !this.form.splits.workouts) return []

      const allExercises = this.form.splits.workouts.flatMap((split) => split.exercises || [])
      return allExercises.map((exercise) => exercise._id)
    },
    activeSplitValue() {
      if (this.form.splits && this.form.splits.value) {
        return this.form.splits.value
      }
      return null
    },
    progress() {
      if (this.windowIndex === 1) {
        return this.formWindow === 1 ? 25 : 50
      }
      if (this.windowIndex === 2) return 75
      if (this.windowIndex === 3) return 100
      return 0
    },
    isNextDisabled() {
      if (this.windowIndex === 1 && this.formWindow === 1) {
        return !this.form.user_id || !this.form.instructor_id
      }
      if (this.windowIndex === 1 && this.formWindow === 2) {
        return !this.form.splits || !this.form.splits.text
      }
      return false
    },
    formTitle() {
      switch (this.windowIndex) {
        case 1:
          return this.formWindow === 1 ? (this.isInEditMode ? "Plan bearbeiten" : "Plan erstellen") : "Wähle deinen Split"
        case 2:
          return "Workout zusammenstellen"
        case 3:
          return "Übersicht & Abschluss"
        default:
          return this.form.title || "Trainingsplan"
      }
    },
    isInEditMode() {
      return !!this.$route.params.id
    },
  },
  methods: {
    ...mapActions("runWorkoutStore", ["resetPlanForConversion", "loadOldPlansForUser", "resetPlanForCloning"]),
    ...mapActions("workingoutStore", ["resetPlanInEditMode", "resetWorkoutV2CreateForm", "updateWorkoutV2CreateForm"]), // Passe Actions an
    copyForm(form) {
      return JSON.parse(JSON.stringify(form || {}))
    },
    applyMttOwnership(form) {
      const securedForm = this.copyForm(form)
      securedForm.user_id = this.$route.params.customerId
      securedForm.instructor_id = userService.getUserId()
      delete securedForm.selectedEmployeeId
      delete securedForm.appointmentId
      return securedForm
    },
    isUsableDraft(draft) {
      return (
        draft &&
        draft.splits &&
        Array.isArray(draft.splits.workouts) &&
        draft.splits.workouts.length > 0 &&
        draft.splits.workouts.some((split) => Array.isArray(split.exercises) && split.exercises.length > 0)
      )
    },
    async initializeMttMode() {
      this.mttLoading = true
      const customerId = this.$route.params.customerId

      try {
        const result = await api.workoutApi.fetchMttCustomerWorkouts(customerId)
        this.mttCustomer = result.customer
        this.resetPlanInEditMode()

        if (this.isInEditMode) {
          const plan = (result.workouts || []).find((workout) => String(workout._id) === String(this.$route.params.id))
          if (!plan) throw new Error("MTT_WORKOUT_NOT_FOUND")
          if (plan.deleted === true) throw new Error("MTT_WORKOUT_ARCHIVED")

          this.form = this.applyMttOwnership(plan)
          this.formWindow = 2
          this.windowIndex = 2
          return
        }

        const draft = this.workoutV2Create && this.workoutV2Create.form
        const draftMatchesCustomer = draft && String(draft.user_id || "") === String(customerId)
        if (draftMatchesCustomer && this.isUsableDraft(draft)) {
          this.form = this.applyMttOwnership(draft)
          this.formWindow = 2
          this.windowIndex = 1
          this.showRestoreDraftDialog = true
          return
        }

        this.startFreshMttPlan()
      } catch (error) {
        console.error("MTT-Editor konnte nicht initialisiert werden:", error)
        const archived = error && error.message === "MTT_WORKOUT_ARCHIVED"
        this.$toast.error(
          archived ? "Archivierte Pläne müssen zuerst wiederhergestellt werden." : "Der MTT-Kunde oder Plan ist nicht mehr verfügbar.",
        )
        this.$router.replace(this.mttHubRoute()).catch(() => {})
      } finally {
        this.mttLoading = false
      }
    },
    startFreshMttPlan() {
      this.resetWorkoutV2CreateForm()
      this.form = this.applyMttOwnership(this.workoutV2Create.form)
      this.formWindow = 2
      this.windowIndex = 1
    },
    mttHubRoute(refresh = false) {
      const query = {
        mode: "mtt",
        customerId: this.$route.params.customerId,
      }
      if (refresh) query.refresh = String(Date.now())
      return { name: "Workouts_v2", query }
    },
    handleMttSaveFailure(error) {
      if (!this.isMttMode || !error || !error.response) return false
      if (error.response.status === 403) {
        this.$toast.error("Die MTT-Berechtigung des Kunden ist nicht mehr gültig.")
        this.$router.replace({ name: "Workouts_v2", query: { mode: "mtt" } }).catch(() => {})
        return true
      }
      if (error.response.status === 409) {
        this.$toast.error("Der Plan wurde archiviert und muss zuerst wiederhergestellt werden.")
        this.$router.replace(this.mttHubRoute(true)).catch(() => {})
        return true
      }
      return false
    },
    debouncedUpdate: debounce(function (newForm) {
      if (!this.isInEditMode) {
        this.updateWorkoutV2CreateForm(newForm)
      }
    }, 500),
    handleRestoreDraft() {
      this.form = this.isMttMode ? this.applyMttOwnership(this.workoutV2Create.form) : this.workoutV2Create.form
      this.windowIndex = 2 // Springe direkt in den Editor
      this.showRestoreDraftDialog = false
    },

    // Wird aufgerufen, wenn der User den Entwurf verwerfen und neu starten möchte
    handleDiscardDraft() {
      this.resetWorkoutV2CreateForm() // Leert den Entwurf im Store
      this.showRestoreDraftDialog = false

      if (this.isMttMode) {
        this.startFreshMttPlan()
        return
      }

      // Führe jetzt die Logik aus, um einen leeren Plan zu starten
      // und eventuell vorausgefüllte IDs zu übernehmen
      this.startFreshPlan()
    },

    // Hilfsmethode, um doppelten Code zu vermeiden
    startFreshPlan() {
      if (this.isMttMode) {
        this.startFreshMttPlan()
        return
      }

      this.form = JSON.parse(JSON.stringify(this.workoutV2Create.form))

      const customerId = this.$route.query.userId || this.selectedCustomer?._id
      const instructorId = this.getSelectedEmployee?.user
      if (customerId) this.form.user_id = customerId
      if (instructorId) this.form.instructor_id = instructorId

      if (this.form.user_id && this.form.instructor_id) {
        this.$nextTick(async () => {
          this.formWindow = 2
          await this.loadOldPlansForUser(this.form.user_id)
          if (this.oldWorkoutPlans && this.oldWorkoutPlans.length > 0 && !this.isInEditMode && this.$route.params.isClone !== "true") {
            this.showOldPlansDialog = true
          }
        })
      }
    },
    handleSplitSelection(selection) {
      const hasExercises =
        this.form.splits && this.form.splits.workouts && this.form.splits.workouts.some((w) => w.exercises && w.exercises.length > 0)

      const selectionValue = typeof selection === "string" ? selection : selection.value
      const currentValue = this.form.splits ? this.form.splits.value : null

      if (selectionValue === currentValue) {
        return
      }

      if (hasExercises) {
        this.pendingSplitSelection = selection
        this.showSplitChangeConfirmDialog = true
      } else {
        this.applySplitSelection(selection)
      }
    },

    applySplitSelection(selection) {
      if (selection === "customSplit") {
        this.startCustomSplitCreation()
      } else {
        this.$set(this.form, "splits", JSON.parse(JSON.stringify(selection)))
        this.$set(this.form, "title", selection.text)
      }
    },

    confirmSplitChange() {
      this.applySplitSelection(this.pendingSplitSelection)
      this.showSplitChangeConfirmDialog = false
      this.pendingSplitSelection = null
    },

    cancelSplitChange() {
      this.showSplitChangeConfirmDialog = false
      this.pendingSplitSelection = null
    },
    startConversion() {
      this.showOldPlansDialog = false
      this.showConversionDialog = true
    },
    skipConversion() {
      this.showOldPlansDialog = false
      this.formWindow = 2
    },
    async handleNextStep() {
      if (this.isNextDisabled) return

      if (this.windowIndex === 2) {
        this.handleNextStepForSplit = true
        return
      }

      if (this.windowIndex === 1) {
        if (this.formWindow === 1) {
          if (this.isMttMode) {
            this.formWindow = 2
            return
          }

          if (this.$refs.createForm && !this.$refs.createForm.validate()) {
            this.noInstructorSnackbar = true
            return
          }
          this.noInstructorSnackbar = false

          await this.loadOldPlansForUser(this.form.user_id)
          if (this.oldWorkoutPlans && this.oldWorkoutPlans.length > 0 && !this.isInEditMode && this.$route.params.isClone !== "true") {
            this.showOldPlansDialog = true
          } else {
            this.formWindow = 2
          }
        } else {
          this.windowIndex = 2
        }
      }
    },

    onConversionComplete() {
      if (this.planForConversion) {
        const convertedData = JSON.parse(JSON.stringify(this.planForConversion))
        this.form.title = convertedData.title
        this.form.splits = convertedData.splits
        this.form.duration = convertedData.duration

        this.resetPlanForConversion()
      }
      this.showConversionDialog = false
      this.windowIndex = 2
    },
    handleBackStep() {
      this.handleNextStepForSplit = false
      if (this.windowIndex === 3) {
        this.windowIndex = 2
      } else if (this.windowIndex === 2) {
        this.windowIndex = 1
        this.formWindow = 2
      } else if (this.windowIndex === 1) {
        if (this.formWindow === 2) {
          if (this.isMttMode) {
            this.closeCreateView()
            return
          }
          this.formWindow = 1
        }
      }
    },
    async updateWorkoutPlan() {
      const payload = this.isMttMode
        ? this.applyMttOwnership(this.form)
        : {
            ...this.form,
            selectedEmployeeId: this.getSelectedEmployee ? this.getSelectedEmployee.user : null,
            appointmentId: this.$route.query.appointmentId || null,
          }

      try {
        await api.workoutApi.updateTrainingsPlan(payload._id, payload, this.workoutAccessMode) // Annahme: update-Route braucht ID und Daten
        this.$toast.success("Trainingsplan erfolgreich aktualisiert")
        this.closeWorkoutForm(true)
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Plans:", error)
        if (this.handleMttSaveFailure(error)) return
        this.$toast.error("Ein Fehler beim Update ist aufgetreten.")
      }
    },
    selectSplit(split) {
      if (this.addWorkoutToSplit) return
      this.$set(this.form, "splits", JSON.parse(JSON.stringify(split)))
      this.$set(this.form, "title", split.text)
    },
    startCustomSplitCreation() {
      this.$set(this.form, "splits", {
        text: "Eigener Split",
        value: "customSplit",
        info: "Ein benutzerdefinierter Split mit individuellen Trainingstagen.",
        workouts: [],
      })
      this.$set(this.form, "title", "Eigener Split")
      this.addWorkoutToSplit = true
    },
    addNewSplit(newSplitName) {
      if (!this.form.splits.workouts) {
        this.$set(this.form.splits, "workouts", [])
      }
      this.form.splits.workouts.push({
        title: newSplitName,
        exercises: [],
        recommendedTags: [],
      })
    },
    addWorkoutDay() {
      if (!this.addNewSplitText || !this.addNewSplitText.trim()) return
      this.addNewSplit(this.addNewSplitText.trim())
      this.addNewSplitText = ""
    },
    removeWorkoutDay(index) {
      if (this.form.splits && this.form.splits.workouts) {
        this.form.splits.workouts.splice(index, 1)
      }
    },
    cancelCustomSplitCreation() {
      this.form.splits = { text: "", workouts: [] }
      this.form.title = ""
      this.addNewSplitText = ""
      this.addWorkoutToSplit = false
    },
    finishCustomSplitCreation() {
      this.addWorkoutToSplit = false
      this.handleNextStep()
    },
    updateCustomer(id) {
      this.form.user_id = id
    },
    updateInstructor(id) {
      this.form.instructor_id = id
    },
    async createWorkoutPlan() {
      if (this.isInEditMode) {
        await this.updateWorkoutPlan()
        return // Wichtig: beende die Ausführung hier
      }

      const payload = this.isMttMode
        ? this.applyMttOwnership(this.form)
        : {
            ...this.form,
            selectedEmployeeId: this.getSelectedEmployee ? this.getSelectedEmployee.user : null,
            appointmentId: this.$route.query.appointmentId || null,
          }

      try {
        await api.workoutApi.createTrainingsPlan(payload, this.workoutAccessMode)
        this.$toast.success("Trainingsplan erfolgreich erstellt")
        this.closeWorkoutForm(true)
      } catch (error) {
        console.error("Fehler beim Erstellen des Plans:", error)
        if (this.handleMttSaveFailure(error)) return
        this.$toast.error("Ein Fehler ist aufgetreten.")
      }
    },

    closeCreateView() {
      this.dialog = false
      this.$nextTick(() => {
        if (this.isMttMode) {
          this.$router.push(this.mttHubRoute(true)).catch(() => {})
          return
        }

        const appointmentId = this.$route.query.appointmentId
        const date = this.$route.query.date
        if (appointmentId && date) {
          this.$router.push({
            path: "/work-calendar",
            query: { appointmentId, date },
          })
          return
        }

        const formCustomer = this.form && this.form.user_id
        const customerId = this.$route.query.userId || (formCustomer && formCustomer._id) || formCustomer
        if (customerId && userService.hasRight("u_search")) {
          this.$router
            .push({
              name: "userDashboardCustomerSelected",
              params: { id: String(customerId) },
              query: { section: "training" },
            })
            .catch(() => {})
          return
        }

        this.$router.push(this.isInEditMode && !userService.hasRight("u_search") ? "/workout/hub" : "/")
      })
    },
    closeWorkoutForm(push) {
      this.resetWorkoutV2CreateForm() // Leert den zwischengespeicherten Entwurf
      this.resetPlanInEditMode()
      this.$emit("reload-workouts")
      if (push) {
        this.closeCreateView()
      }
    },
  },
  watch: {
    // Speichert das Formular bei jeder Änderung im neuen, persistenten State
    form: {
      handler(newForm) {
        this.debouncedUpdate(newForm)
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.mobile-wizard-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #121212;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  color: white;
}
.mtt-editor-banner {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  min-height: 66px;
  padding: 10px 20px;
  background: linear-gradient(90deg, rgba(25, 25, 27, 0.98), rgba(49, 49, 49, 0.98));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  z-index: 4;
}
.mtt-editor-banner__customer,
.mtt-editor-banner__physio {
  min-width: 0;
}
.mobile-wizard-container--mtt .mobile-wizard-content.fullscreen-content {
  height: auto;
  min-height: 0;
}
.mobile-wizard-progress {
  position: absolute;
  top: 88px;
  left: 0;
  width: 100%;
  z-index: 1;
  transition: all 0.4s ease-in-out;
}
@media (max-width: 520px) {
  .mtt-editor-banner {
    padding: 9px 12px;
  }
  .mtt-editor-banner__physio {
    display: none;
  }
}
.mobile-wizard-content {
  flex-grow: 1;
  overflow-y: auto;
  padding: 50px 24px 10px 24px;
  &.fullscreen-content {
    padding: 0;
    height: 100vh;
    overflow-y: hidden;
  }
}
.mobile-wizard-step {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.mobile-wizard-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 24px;
  background: linear-gradient(to top, rgba(18, 18, 18, 1) 70%, rgba(18, 18, 18, 0));
  display: flex;
  align-items: center;
  z-index: 2;
}

/* NEUES DESIGN FÜR AUSWAHL-KARTEN (aus planConverter) */
.split-item {
  border-radius: 16px !important;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  margin-bottom: 8px; /* Kleiner Abstand zwischen den Karten */
}
.split-item.split-item--active {
  background-color: rgba(0, 150, 63, 0.2);
  border-color: var(--v-primary-base);
  box-shadow: 0 0 20px rgba(0, 150, 63, 0.5);
}

/* --- NEUES "TKOKSTYLE" DESIGN FÜR DEN DIALOG --- */
::v-deep .custom-split-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.custom-split-dialog-card {
  background-color: #1e1e1e !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3E%3Cpath fill='%23343434' fill-opacity='0.4' d='M1 3h1v1H1V3zm2-2h1v1H3V1z'%3E%3C/path%3E%3C/svg%3E");
  border: 1px solid #444;
  border-radius: 16px !important;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.5);
}

::v-deep .v-text-field.v-text-field--solo .v-input__control {
  min-height: 60px;
  .v-input__slot {
    background-color: rgba(0, 0, 0, 0.3) !important;
    border-radius: 12px !important;
    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.4) !important;
    transition: background-color 0.3s ease;
    &:focus-within {
      background-color: rgba(0, 0, 0, 0.5) !important;
    }
  }
}
.glass-overlay {
  position: relative;
  z-index: 1;
  background: rgba(42, 42, 42, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.animated-icon {
  animation: scale-in 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.pulse-animation {
  animation: pulse 2s infinite;
  box-shadow: 0 0 0 0 rgba(var(--v-primary-base-rgb), 0.7);
}
@keyframes scale-in {
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(var(--v-primary-base-rgb), 0.4);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(var(--v-primary-base-rgb), 0);
  }
  100% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(var(--v-primary-base-rgb), 0);
  }
}

::v-deep .wow-dialog-card {
  background-color: transparent !important;
  box-shadow: none !important;
}
.custom-chip {
  background: linear-gradient(135deg, var(--v-primary-base), var(--v-primary-darken2)) !important;
  font-weight: bold;
  color: white !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

  .v-icon {
    color: white !important;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }
}
</style>
